function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {},
    width: 21,
    height: 21.02,
    viewBox: "0 0 21 21.02",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.000000 -0.000000 L7.000000 2.000000 L2.000000 2.000000 L2.000000 16.000000 L16.000000 16.000000 L16.000000 11.000000 L18.000000 11.000000 L18.000000 17.000000 C18.000000 17.280001 17.903334 17.516666 17.710000 17.710000 C17.516666 17.903334 17.280001 18.000000 17.000000 18.000000 L1.000000 18.000000 C0.719999 18.000000 0.483334 17.903334 0.290000 17.710000 C0.096666 17.516666 0.000000 17.280001 0.000000 17.000000 L0.000000 1.000000 C0.000000 0.719999 0.096666 0.483334 0.290000 0.290000 C0.483334 0.096666 0.719999 -0.000000 1.000000 -0.000000 Z M14.580000 2.000000 L10.000000 2.000000 L10.000000 -0.000000 L18.000000 -0.000000 L18.000000 8.000000 L16.000000 8.000000 L16.000000 3.420000 L9.000000 10.420000 L7.580000 9.000000 Z M21.000000 21.000000",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e05280e8.svg";
export { ForwardRef as ReactComponent };